import { lazy } from 'react';

const LazyMainContainer = lazy(() => import('./main-container'));
export default LazyMainContainer;
